import { createFileRoute } from '@tanstack/react-router'
import { PackConfigPage } from '../../../../modules/settings/pack-config-page'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

/** A specific vertical pack's config editor (platform-admin pack browsing). */
export const Route = createFileRoute('/_authed/settings/packs/$packId')({
  component: PackRoute,
})

function PackRoute() {
  const { packId } = Route.useParams()
  return (
    <SettingsShell>
      <PackConfigPage packId={packId} />
    </SettingsShell>
  )
}
